import { FC } from 'react';

interface RadioProps {
  checked: boolean;
  onChange: () => void;
  label?: string;
  className?: string;
}

const Radio: FC<RadioProps> = ({ checked, onChange, label, className = '' }) => {
  return (
    <div 
      className={`flex items-center cursor-pointer ${className}`}
      onClick={onChange}
    >
      {label && (
        <span className="text-gray-700 leading-relaxed flex-grow pr-4">
          {label}
        </span>
      )}
      <div className="relative">
        <div 
          className={`w-5 h-5 border-2 rounded-full transition-colors ${
            checked ? 'border-radio-active' : 'border-gray-300'
          }`}
        >
          {checked && (
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-2.5 h-2.5 bg-radio-active rounded-full" />
          )}
        </div>
      </div>
    </div>
  );
};

export default Radio; 